import { Pipe, PipeTransform } from '@angular/core';

import { BLOG_COPY } from '../constants/blog.constants';
import { formatBlogDate } from '../utils/blog-format.util';

/** `publishedAt` (ISO 8601) → «22 mar 2026», en hora de Costa Rica. */
@Pipe({ name: 'blogDate' })
export class BlogDatePipe implements PipeTransform {
  transform(publishedAt: string): string {
    return formatBlogDate(publishedAt);
  }
}

/** `readTimeMinutes` → «7 min de lectura» (sufijo de `BLOG_COPY`, B16). */
@Pipe({ name: 'blogReadTime' })
export class BlogReadTimePipe implements PipeTransform {
  transform(minutes: number): string {
    return BLOG_COPY.readTime(minutes);
  }
}
